import { render, staticRenderFns } from "./pencil-24.vue?vue&type=template&id=219f9938&scoped=true"
import script from "./pencil-24.vue?vue&type=script&lang=js"
export * from "./pencil-24.vue?vue&type=script&lang=js"
import style0 from "./pencil-24.vue?vue&type=style&index=0&id=219f9938&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f9938",
  null
  
)

export default component.exports